import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class ServiceentityStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.services = [];
    this.trending = [];
  }

  handleLoadSuccess(services) {
    this.services = services;
    this.emitChange();
  }
  handleLoadTrendingSuccess(trendingList) {
    this.trending = trendingList;
    this.emitChange();
  }
  get() {
    return {
      service: this.services,
      trending: this.trending
    };
  }

  dehydrate() {
    return {
      services: this.services,
      trending: this.trending
    };
  }

  rehydrate(state) {
    this.services = state.services;
  }
}

ServiceentityStore.storeName = 'ServiceentityStore';
ServiceentityStore.handlers = {
  [Actions.LOAD_ENTITYSERVICE_SUCCESS]: 'handleLoadSuccess',
  [Actions.LOAD_SERVICETRENDING_SUCCESS]: 'handleLoadTrendingSuccess',
};

export default ServiceentityStore;


// WEBPACK FOOTER //
// ./src/stores/ServiceentityStore.js